export default __webpack_public_path__ + "static/media/Shopping_car.c1501e31.svg";